/* @jsxImportSource react */

import * as React from 'react';

export type PriceOldPriceProps = {
  children: React.ReactNode;
  /* 
    Defines if the old price can have a strikethrough style, for legal reasons this may not always be allowed.

    As this also can vary between different regions/tenants, the styling itself is handled in the theme CSS.
   */
  allowStrikethrough?: boolean;
};

const PriceOldPrice = ({ children, allowStrikethrough }: PriceOldPriceProps) => (
  <span
    className={`price-old-price ${allowStrikethrough ? 'allow-strikethrough' : ''} text-size-body-xs text-color-text-dark inline-flex grow-0 items-center justify-start empty:hidden`}
  >
    {children}
  </span>
);

PriceOldPrice.displayName = 'Price.OldPrice';

export { PriceOldPrice };
